import { render, staticRenderFns } from "./SyllabusSubEffectsModal.vue?vue&type=template&id=6b03fc28&scoped=true&"
import script from "./SyllabusSubEffectsModal.vue?vue&type=script&lang=js&"
export * from "./SyllabusSubEffectsModal.vue?vue&type=script&lang=js&"
import style0 from "./SyllabusSubEffectsModal.vue?vue&type=style&index=0&id=6b03fc28&scoped=true&lang=scss&"
import style1 from "./SyllabusSubEffectsModal.vue?vue&type=style&index=1&id=6b03fc28&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b03fc28",
  null
  
)

export default component.exports